import { render, staticRenderFns } from "./sw-announcement-banner.vue?vue&type=template&id=a19bd910&scoped=true&"
import script from "./sw-announcement-banner.vue?vue&type=script&lang=ts&"
export * from "./sw-announcement-banner.vue?vue&type=script&lang=ts&"
import style0 from "./sw-announcement-banner.vue?vue&type=style&index=0&id=a19bd910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19bd910",
  null
  
)

export default component.exports